import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export function SpotifyIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M11.75,0A11.75,11.75,0,1,0,23.5,11.75,11.75,11.75,0,0,0,11.75,0m5.39,17a.74.74,0,0,1-1,.24h0C13.37,15.5,9.9,15.12,5.81,16.06a.73.73,0,0,1-.33-1.43h0c4.48-1,8.32-.58,11.42,1.31a.74.74,0,0,1,.24,1m1.44-3.2a.92.92,0,0,1-1.26.3A15.45,15.45,0,0,0,5.61,12.68a.92.92,0,0,1-.53-1.75,17.09,17.09,0,0,1,13.19,1.56.91.91,0,0,1,.31,1.26h0m.12-3.33C14.91,8.17,8.66,8,5.05,9.06a1.1,1.1,0,0,1-1.38-.71A1.09,1.09,0,0,1,4.38,7h0c4.15-1.26,11.05-1,15.41,1.57a1.1,1.1,0,0,1-1.12,1.89" />
        </SvgIcon>
    );
}
